import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock, CreditCard, Zap } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="py-8 md:py-16 px-4 bg-[#2B2724] text-white" data-id="element-74">
      <div className="max-w-6xl mx-auto" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-76">
          <h2 className="text-2xl md:text-5xl font-bold mb-4 md:mb-6" data-id="element-77">
            No dejes pasar esta oportunidad
          </h2>

          <p className="text-sm md:text-lg mb-3 md:mb-4" data-id="element-78">Termina en</p>

          <CountdownTimer data-id="element-79" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-8 md:mb-12" data-id="element-80">
          {/* Esencial */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white/10 backdrop-blur-sm rounded-lg p-5 md:p-8 border-2 border-white/20 flex flex-col justify-between" data-id="element-81">
            <div data-id="element-82">
              <h3 className="text-lg md:text-2xl font-bold mb-1 md:mb-2" data-id="element-83">
                MEGAPACK MUEBLES JAPANDI — ESENCIAL
              </h3>
              <p className="text-xs md:text-sm text-white/70 mb-4 md:mb-6" data-id="element-84">
                6 tomos + 5 bonos estratégicos
              </p>

              <div className="mb-4 md:mb-6" data-id="element-85">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-86">
                  <span className="text-lg md:text-2xl text-white/40 line-through" data-id="element-87">
                    $34.990
                  </span>
                  <span className="text-3xl md:text-5xl font-bold text-[#C2613A]" data-id="element-88">
                    $19.990
                  </span>
                </div>
              </div>
            </div>

            <a href="#" className="block w-full bg-white hover:bg-gray-100 text-[#2B2724] text-center py-3 md:py-4 rounded-lg text-sm md:text-base font-bold transition-colors" data-id="element-89">
              QUIERO EL MEGAPACK ESENCIAL
            </a>
          </motion.div>

          {/* PRO */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-[#C2613A] rounded-lg p-5 md:p-8 border-2 border-[#C2613A] relative shadow-xl flex flex-col justify-between mt-4 md:mt-0" data-id="element-90">
            <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-white text-[#2B2724] px-4 md:px-6 py-1 md:py-2 rounded-full text-[10px] md:text-sm font-bold whitespace-nowrap" data-id="element-91">
              ⭐ MÁS ELEGIDO
            </div>

            <div data-id="element-92">
              <div className="bg-white/20 backdrop-blur-sm px-3 md:px-4 py-1 rounded-full text-[10px] md:text-xs font-semibold inline-block mb-3 md:mb-4" data-id="element-93">
                AHORRÁS $10.000
              </div>

              <h3 className="text-lg md:text-2xl font-bold mb-1 md:mb-2" data-id="element-94">
                MEGAPACK MUEBLES JAPANDI — PRO
              </h3>
              <p className="text-xs md:text-sm text-white/80 mb-4 md:mb-6" data-id="element-95">
                6 tomos + 5 bonos + Tomo 7 + Tomo 8
              </p>

              <div className="mb-4 md:mb-6" data-id="element-96">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-97">
                  <span className="text-lg md:text-2xl text-white/40 line-through" data-id="element-98">
                    $43.990
                  </span>
                  <span className="text-3xl md:text-5xl font-bold" data-id="element-99">
                    $29.990
                  </span>
                </div>
              </div>
            </div>

            <div data-id="element-100">
              <a href="#" className="block w-full bg-white hover:bg-gray-100 text-[#C2613A] text-center py-3 md:py-4 rounded-lg text-sm md:text-base font-bold transition-colors mb-3 md:mb-4" data-id="element-101">
                SÍ, QUIERO EL MEGAPACK PRO
              </a>

              <p className="text-[10px] md:text-xs text-white/80 text-center" data-id="element-102">
                La opción más elegida por fabricantes que quieren convertirlo en
                negocio real
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-wrap justify-center gap-3 md:gap-6 text-[10px] md:text-sm" data-id="element-103">
          <div className="flex items-center gap-1 md:gap-2" data-id="element-104">
            <ShieldCheck className="w-4 h-4 md:w-5 md:h-5 text-[#C2613A]" data-id="element-105" />
            <span data-id="element-106">Pago seguro</span>
          </div>
          <div className="flex items-center gap-1 md:gap-2" data-id="element-107">
            <Clock className="w-4 h-4 md:w-5 md:h-5 text-[#C2613A]" data-id="element-108" />
            <span data-id="element-109">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-1 md:gap-2" data-id="element-110">
            <Zap className="w-4 h-4 md:w-5 md:h-5 text-[#C2613A]" data-id="element-111" />
            <span data-id="element-112">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1 md:gap-2" data-id="element-113">
            <CreditCard className="w-4 h-4 md:w-5 md:h-5 text-[#C2613A]" data-id="element-114" />
            <span data-id="element-115">Mercado Pago</span>
          </div>
        </motion.div>
      </div>
    </section>;
}